module.exports = __webpack_public_path__ + "img/reduction.fbd1a9dd.svg";